import {
  DESIGN_PROJECT_ID,
  designInitialConnections,
  designInitialProjectPackages,
} from './designFixtures';
import { WORKFLOW_TEMPLATES } from './workflowTemplates';

const INBOX_SCENARIO = {
  id: DESIGN_PROJECT_ID,
  name: 'Inbox extract fleet',
  summary:
    'Linear agent fleet: mailbox in, extract senders, look up publications, write JSON, store.',
  patterns: ['linear', 'agent'],
  family: 'agentic',
  packages: designInitialProjectPackages,
  connections: designInitialConnections,
};

export function undeployPackages(packages) {
  return (packages || []).map((pkg) => ({
    ...pkg,
    deploy_status: 'NOT_DEPLOYED',
    output_data: {},
  }));
}

export const DEMO_SCENARIOS = [
  {
    ...WORKFLOW_TEMPLATES.find((t) => t.id === 'tpl-harness-lifecycle'),
    family: 'lifecycle',
    watchOnLoad: true,
  },
  INBOX_SCENARIO,
  ...WORKFLOW_TEMPLATES.filter((t) => t.id !== 'tpl-harness-lifecycle').map(
    (t) => ({
      ...t,
      family: 'agentic',
    })
  ),
];

export const DEMO_SCENARIO_IDS = new Set(DEMO_SCENARIOS.map((s) => s.id));

export const DEFAULT_DEMO_SCENARIO_ID = 'tpl-harness-lifecycle';

export function getDemoScenario(id) {
  return DEMO_SCENARIOS.find((s) => s.id === id) || null;
}

export function demoScenarioGroups() {
  return [
    {
      id: 'lifecycle',
      title: 'Lifecycle',
      blurb: 'Bash harness. Watch apply then destroy.',
      items: DEMO_SCENARIOS.filter((s) => s.family === 'lifecycle'),
    },
    {
      id: 'agentic',
      title: 'Agentic',
      blurb: 'Latest timer, fan-out, join, and linear fleets.',
      items: DEMO_SCENARIOS.filter((s) => s.family === 'agentic'),
    },
  ];
}
